// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2Qv0X","issueOptionsModel":"style_issueOptionsModel__eO4Bh"};